import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const Spinner = ({ message, color, size }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: "300px",
        "& .MuiCircularProgress-root": {
          color: (theme) => theme.palette.warning.main,
        },
      }}
    >
      <CircularProgress size={80} thickness={2.5} />
      <Typography
        variant="h6"
        mt={3}
        color="textSecondary"
        sx={{
          fontWeight: "bold",
          letterSpacing: "1px",
          color: (theme) => theme.palette.primary.main,
        }}
      >
        IT ENGINE SPARKS
      </Typography>

      <Typography variant="h6" sx={{ marginTop: 2 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default Spinner;
